import {
  FETCH_STATS_SUCCESS,
  FETCH_CURRENT_STATS_SUCCESS,
  FETCH_ABSENCE_STATS_SUCCESS,
  OPEN_USER_STATS
} from 'actions/types'

import { produce } from "immer";

const initialState = {
  userStats: [],
  currentStats: [],
  absenceStats: [],
  openUserStats: false
}

const statsReducer = (state = initialState, action) => 
produce(state, draft => {
  switch (action.type) {
    case FETCH_STATS_SUCCESS:
      draft.userStats = action.payload
      break
    case FETCH_CURRENT_STATS_SUCCESS:
      draft.currentStats = action.payload
      break
    case FETCH_ABSENCE_STATS_SUCCESS:
      draft.absenceStats = action.payload
      break
    case OPEN_USER_STATS:
      draft.openUserStats = action.payload
      break
    default: return state
  }
})
  
    
export default statsReducer   